<span class="unauthenticated-header-wrapper flex-wrap">
  <ul
    class="nav align-items-center header-link-nav-bar d-none d-md-flex column-gap-4"
  >
    <li class="nav-item">
      <a routerLink="/lost-and-found">Lost &amp; found</a>
    </li>
    <li class="nav-item">
      <a routerLink="/contact-us">Contact us</a>
    </li>
    <ng-container *appFeatureFlag="'isHeaderIdentiProfessionalsEnabled'">
      <li class="nav-item">
        <a routerLink="/identi-professionals">identi professionals</a>
      </li>
    </ng-container>
  </ul>

  <ng-container *appFeatureFlag="'isHeaderInformationDropDownEnabled'">
    <ul class="nav align-items-center header-icon-nav-toggle d-none d-md-flex">
      <li
        ngbDropdown
        display="dynamic"
        placement="bottom-right"
        class="nav-item ms-4"
        (openChange)="opened($event)"
      >
        <button ngbDropdownToggle class="nav-info nav-link">Information</button>
        <div ngbDropdownMenu>
          <div>
            <a ngbDropdownItem routerLink="/microchipping-your-pet">Microchipping</a>
            <a ngbDropdownItem href="https://identicare.zendesk.com/hc/en-us" target="_blank">
              Help Centre
            </a>
            <a ngbDropdownItem href="https://identiblog.zendesk.com/hc/en-us" target="_blank">
              Blog
            </a>
          </div>
        </div>
      </li>
    </ul>
  </ng-container>

  <ul class="nav align-items-center header-link-nav-bar d-none d-md-flex">
    <div class="nav-item-divider"></div>

    <li class="nav-item">
      <a routerLink="/login-register" class="fw-bold">Log in | Register</a>
    </li>

    <div class="nav-item-divider"></div>

    <li class="nav-item me-2">
      <a routerLink="/claim-pet" class="fw-bold">Transfer of Keepership</a>
    </li>

    <li>
      <app-social-facebook
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-facebook>
    </li>
    <li>
      <app-social-instagram
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-instagram>
    </li>
    <li>
      <app-social-twitter [badgeWrapperSize]="'32px'" [badgeIconSize]="'20px'"></app-social-twitter>
    </li>
  </ul>

  <ul class="nav align-items-center d-flex d-md-none">
    <li
      ngbDropdown
      display="dynamic"
      placement="bottom-right"
      class="nav-item"
      (openChange)="opened($event)"
    >
      <button ngbDropdownToggle class="nav-avatar nav-link">
        <span *ngIf="pets.length" class="nav-avatar-circle">
          <span
            class="nav-avatar-img"
            [ngStyle]="{
              'background-image': pets[0].imageId
                ? 'url(' + getPetImageUrl(pets[0].imageId) + ')'
                : 'none',
            }"
          >
            <span *ngIf="!pets[0].imageId" class="fw-bold">
              {{ pets[0].name.trim().charAt(0) | uppercase }}
            </span>
          </span>
        </span>
        <span *ngIf="!pets.length" class="nav-avatar-circle">
          <span class="nav-avatar-img">
            <fa-icon [icon]="['fas', 'user']" [fixedWidth]="true"></fa-icon>
          </span>
        </span>
      </button>
      <div ngbDropdownMenu>
        <div>
          <a ngbDropdownItem routerLink="/login-register" class="fw-bold">Log in | Register</a>
        </div>
        <div class="dropdown-divider"></div>
        <a
          ngbDropdownItem
          routerLink="/claim-pet"
          class="d-block d-md-none fw-bold"
        >
          Transfer of Keepership
        </a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem routerLink="/microchipping-your-pet">Microchipping</a>
        <a ngbDropdownItem routerLink="/lost-and-found">Lost &amp; found</a>
        <a ngbDropdownItem routerLink="/contact-us">Contact us</a>
        <a ngbDropdownItem *appFeatureFlag="'isHeaderIdentiProfessionalsEnabled'" routerLink="/identi-professionals">identi professionals</a>
        <a ngbDropdownItem *appFeatureFlag="'isHeaderInformationDropDownEnabled'" href="https://identicare.zendesk.com/hc/en-us" target="_blank">
          Help Centre
        </a>
        <a ngbDropdownItem *appFeatureFlag="'isHeaderInformationDropDownEnabled'" href="https://identiblog.zendesk.com/hc/en-us" target="_blank">Blog</a>

        <span
          *appFeatureFlag="'areSocialsAvailable'"
          class="social-icons-wrapper d-flex justify-content-center gap-2 mt-2 pt-1 border-top"
        >
          <app-social-facebook
            [badgeWrapperSize]="'24px'"
            [badgeIconSize]="'16px'"
          ></app-social-facebook>
          <app-social-instagram
            [badgeWrapperSize]="'24px'"
            [badgeIconSize]="'16px'"
          ></app-social-instagram>
          <app-social-twitter
            [badgeWrapperSize]="'24px'"
            [badgeIconSize]="'16px'"
          ></app-social-twitter>
        </span>
      </div>
    </li>
  </ul>
</span>
